import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

// Custom Fork of https://gist.github.com/RedHatter/482d6370f9f9546498890b348636aacb
import React, { useState, useEffect } from 'react';
import { DatePicker } from '@material-ui/pickers';
import { useUtils } from '@material-ui/pickers';
import { fade } from '@material-ui/core/styles';
import withStyles from '@material-ui/core/styles/withStyles';
import clsx from 'clsx';

function DateRangePicker(_ref) {
  var classes = _ref.classes,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? [] : _ref$value,
      onChange = _ref.onChange,
      _labelFunc = _ref.labelFunc,
      format = _ref.format,
      emptyLabel = _ref.emptyLabel,
      autoOk = _ref.autoOk,
      _onOpen = _ref.onOpen,
      _onClose = _ref.onClose,
      openForward = _ref.open,
      props = _objectWithoutProperties(_ref, ["classes", "value", "onChange", "labelFunc", "format", "emptyLabel", "autoOk", "onOpen", "onClose", "open"]);

  var _useState = useState(value[0]),
      _useState2 = _slicedToArray(_useState, 2),
      begin = _useState2[0],
      setBegin = _useState2[1];

  var _useState3 = useState(value[1]),
      _useState4 = _slicedToArray(_useState3, 2),
      end = _useState4[0],
      setEnd = _useState4[1];

  var _useState5 = useState(undefined),
      _useState6 = _slicedToArray(_useState5, 2),
      prevBegin = _useState6[0],
      setPrevBegin = _useState6[1];

  var _useState7 = useState(undefined),
      _useState8 = _slicedToArray(_useState7, 2),
      prevEnd = _useState8[0],
      setPrevEnd = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      hasClicked = _useState10[0],
      setHasClicked = _useState10[1];

  var _useState11 = useState(undefined),
      _useState12 = _slicedToArray(_useState11, 2),
      hover = _useState12[0],
      setHover = _useState12[1];

  var _useState13 = useState(true),
      _useState14 = _slicedToArray(_useState13, 2),
      accepted = _useState14[0],
      setAccepted = _useState14[1];

  var utils = useUtils();
  var min = Math.min(begin, end || hover);
  var max = Math.max(begin, end || hover);

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      open = _useState16[0],
      setOpen = _useState16[1];

  var isOpen = openForward !== undefined ? openForward : open;
  useEffect(function () {
    //Only way to get to this state is is openForward is used
    if (isOpen && accepted && !prevBegin && !prevEnd) {
      setAccepted(false);
      setPrevBegin(begin);
      setPrevEnd(end);
      return;
    } //Closed without accepting, reset to prev state, don't find onChange


    if (!isOpen && !accepted) {
      setBegin(prevBegin);
      setEnd(prevEnd);
      setHover(undefined);
      setHasClicked(false);
    } //Auto ok and hasn't been accepted, but has all the items set, accept and close.
    //This will also triger the on change event by setting isOpen to false


    if (isOpen && autoOk && !accepted && begin && end && hasClicked) {
      setAccepted(true);
      _onClose ? _onClose() : setOpen(false);
    }

    if (accepted && begin && end && !isOpen && hasClicked) {
      setHasClicked(false);
      onChange({
        begin: begin,
        end: end
      });
      _onClose ? _onClose() : setOpen(false);
    }
  }, [begin, end, autoOk, accepted, isOpen, prevBegin, hasClicked, prevEnd, onChange, _onClose]);

  function renderDay(day, selectedDate, dayInCurrentMonth, dayComponent) {
    var _clsx;

    return /*#__PURE__*/React.cloneElement(dayComponent, {
      onClick: function onClick(e) {
        setHasClicked(true);
        e.stopPropagation();
        if (!begin) setBegin(day);else if (!end) {
          if (utils.isBeforeDay(day, begin)) {
            setEnd(begin);
            setBegin(day);
          } else {
            setEnd(day);
          }

          if (autoOk) {
            setPrevBegin(undefined);
            setPrevEnd(undefined);
          }
        } else {
          setBegin(day);
          setEnd(undefined);
        }
      },
      onMouseEnter: function onMouseEnter() {
        return requestAnimationFrame(function () {
          return setHover(day);
        });
      },
      onFocus: function onFocus() {
        return requestAnimationFrame(function () {
          return setHover(day);
        });
      },
      className: clsx(classes.day, (_clsx = {}, _defineProperty(_clsx, classes.hidden, dayComponent.props.hidden), _defineProperty(_clsx, classes.current, dayComponent.props.current), _defineProperty(_clsx, classes.dayDisabled, dayComponent.props.disabled), _defineProperty(_clsx, classes.focusedRange, utils.isAfterDay(day, min) && utils.isBeforeDay(day, max) || utils.isSameDay(day, min) && !utils.isSameDay(day, max) || utils.isSameDay(day, max) && !utils.isSameDay(day, min)), _defineProperty(_clsx, classes.focusedFirst, utils.isSameDay(day, min) && !utils.isSameDay(day, max)), _defineProperty(_clsx, classes.focusedLast, utils.isSameDay(day, max) && !utils.isSameDay(day, min)), _defineProperty(_clsx, classes.beginCap, utils.isSameDay(day, min)), _defineProperty(_clsx, classes.endCap, utils.isSameDay(day, max)), _clsx))
    });
  }

  var formatDate = function formatDate(date) {
    return utils.format(date, format || utils.dateFormat);
  };

  return /*#__PURE__*/React.createElement(DatePicker, _extends({}, props, {
    value: begin,
    renderDay: renderDay,
    open: isOpen,
    onOpen: function onOpen() {
      setAccepted(false);
      setPrevBegin(begin);
      setPrevEnd(end);
      _onOpen ? _onOpen() : setOpen(true);
    },
    onAccept: function onAccept() {
      if (!begin || !end) {
        if (hover && utils.isBeforeDay(begin, hover)) {
          setEnd(hover);
        } else {
          setEnd(begin);
          setBegin(hover);
        }
      }

      setPrevBegin(undefined);
      setPrevEnd(undefined); // if (!autoOk) {

      setAccepted(true); // }
    },
    onClose: function onClose() {
      _onClose ? _onClose() : setOpen(false);
    },
    onChange: function onChange() {},
    labelFunc: function labelFunc(date, invalid) {
      if (!isOpen) {
        if (_labelFunc) {
          return _labelFunc([begin, end], invalid);
        } else {
          if (date && begin && end) {
            return "".concat(formatDate(begin), " - ").concat(formatDate(end));
          } else {
            return emptyLabel || '';
          }
        }
      } else {
        if (prevBegin && prevEnd) {
          if (_labelFunc) {
            return _labelFunc([prevBegin, prevEnd], invalid);
          } else {
            return "".concat(formatDate(prevBegin), " - ").concat(formatDate(prevEnd));
          }
        } else {
          return emptyLabel || '';
        }
      }
    }
  }));
}

__signature__(DateRangePicker, "useState{[begin, setBegin](value[0])}\nuseState{[end, setEnd](value[1])}\nuseState{[prevBegin, setPrevBegin](undefined)}\nuseState{[prevEnd, setPrevEnd](undefined)}\nuseState{[hasClicked, setHasClicked](false)}\nuseState{[hover, setHover](undefined)}\nuseState{[accepted, setAccepted](true)}\nuseUtils{utils}\nuseState{[open, setOpen](false)}\nuseEffect{}", function () {
  return [useUtils];
});

export var styles = function styles(theme) {
  var focusedRangeColor = fade(theme.palette.primary.main, 0.3);
  var focusedRangeGradient = "linear-gradient(to right, ".concat(focusedRangeColor, ", ").concat(focusedRangeColor, ")");
  var transparentRangeGradient = "linear-gradient(to right, rgba(0,0,0,0.0), rgba(0,0,0,0.0))";
  return {
    day: {
      width: 40,
      height: 36,
      fontSize: theme.typography.caption.fontSize,
      margin: 0,
      color: theme.palette.text.primary,
      fontWeight: theme.typography.fontWeightMedium,
      padding: 0,
      transition: 'none',
      '&::after': {
        borderRadius: '100%',
        bottom: 0,
        boxSizing: 'border-box',
        content: '""',
        height: 36,
        width: 36,
        left: 0,
        margin: 'auto',
        position: 'absolute',
        right: 0,
        top: 0,
        transform: 'scale(0)',
        zIndex: 2
      },
      '&:hover': {
        backgroundColor: 'transparent',
        color: theme.palette.text.primary,
        '&::after': {
          backgroundColor: theme.palette.background.paper,
          border: "2px solid ".concat(theme.palette.primary.main),
          bottom: -2,
          left: -2,
          height: 36,
          width: 36,
          right: -2,
          top: -2,
          boxSizing: 'content-box',
          transform: 'scale(1)'
        }
      },
      '& > .MuiIconButton-label': {
        zIndex: 3
      }
    },
    hidden: {
      opacity: 0,
      pointerEvents: 'none'
    },
    current: {
      color: theme.palette.primary.main,
      fontWeight: 600
    },
    focusedRange: {
      color: theme.palette.primary.contrastText,
      background: "".concat(focusedRangeGradient, " no-repeat 0/20px 40px, ") + "".concat(focusedRangeGradient, " no-repeat 20px 0/20px 40px"),
      fontWeight: theme.typography.fontWeightMedium,
      width: 40,
      marginRight: 0,
      marginLeft: 0,
      borderRadius: 0
    },
    dayDisabled: {
      pointerEvents: 'none',
      color: theme.palette.text.hint
    },
    beginCap: {
      '&::after': {
        transform: 'scale(1)',
        backgroundColor: theme.palette.primary.main
      }
    },
    endCap: {
      '&::after': {
        transform: 'scale(1)',
        backgroundColor: theme.palette.primary.main
      }
    },
    focusedFirst: {
      background: "".concat(transparentRangeGradient, " no-repeat 0/20px 40px, ") + "".concat(focusedRangeGradient, " no-repeat 20px 0/20px 40px")
    },
    focusedLast: {
      background: "".concat(focusedRangeGradient, " no-repeat 0/20px 40px, ") + "".concat(transparentRangeGradient, " no-repeat 20px 0/20px 40px")
    }
  };
};

var _default = withStyles(styles, {
  name: 'DateRangePicker'
})(DateRangePicker);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DateRangePicker, "DateRangePicker", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/DatePicker/lib/DateRangePicker.js");
  reactHotLoader.register(styles, "styles", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/DatePicker/lib/DateRangePicker.js");
  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/DatePicker/lib/DateRangePicker.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();